export default [

	// 采购
	{
		path: '/softwareproducts/purchase',
		name: 'purchase',
		meta: {
			title: '采购溯源系统',
			title2: '采购溯源系统-华略未来科技',
		},
		component: () => import('views/softwareProducts/purchase/purchase.vue'),
	},
	// 食堂
	{
		path: '/softwareproducts/canteen',
		name: 'canteen',
		meta: {
			title: '食堂管理系统',
			title2: '食堂管理系统-华略未来科技',
		},
		component: () => import('views/softwareProducts/canteen/canteen.vue'),
	},
	// 大数据
	{
		path: '/softwareproducts/bigdata',
		name: 'bigdata',
		meta: {
			title: '大数据监管系统',
			title2: '大数据监管系统-华略未来科技',
		},
		component: () => import('views/softwareProducts/bigdata/bigdata.vue'),
	},
	// 培训
	{
		path: '/softwareproducts/train',
		name: 'train',
		meta: {
			title: '培训系统',
			title2: '培训系统-华略未来科技',
		},
		component: () => import('views/softwareProducts/train/train.vue'),
	},

];

